import { Box, Button, Typography, LinearProgress } from '@mui/material';

export default function UndoSnackbar({ show, label = 'Item deleted', onUndo, remainingTime }) {
  if (!show) return null;

  const progress = remainingTime ? (remainingTime / 5) * 100 : 0;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 20,
        right: 20,
        backgroundColor: 'white',
        boxShadow: 4,
        p: 2,
        borderRadius: 2,
        zIndex: 1300,
        minWidth: 200,
      }}
    >
      <Typography variant="body2">{label}</Typography>
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{ mt: 1, height: 6, borderRadius: 5 }}
      />
      <Button size="small" onClick={onUndo} sx={{ mt: 1 }}>
        Undo ({Math.max(remainingTime ?? 0, 0)}s)
      </Button>
    </Box>
  );
}